@import 'apps/webcomponents/src/assets/common.scss';
gz-radio {
  --max-width-gz-radio-label: 290px;
}
#beta-programs-radio-group {
  width: 100%;

  .beta-program-row {
    width: 100%;
    display: flex;
    max-height: 32px;
    margin-top: var(--spacer);

    .beta-program-row-el {
      flex: 1;
      display: flex;
      align-items: center;
      min-height: 32px;
      font-size: var(--body-size);
      &:first-child {
        min-width: 314px;
        margin-right: calc(var(--spacer) * 2);
      }

      &:nth-child(2) {
        max-width: 116px;
        margin-right: calc(var(--spacer) * 2);
      }

      .check-mark-span {
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--green-layout-100-primary-green);
      }

      .status {
        margin: 0 0 0 var(--spacer);
        color: var(--main-titles-inputs-600);
      }

      .beta-program-sub-row-el {
        display: flex;
        margin: 0;
        font-size: var(--body-size);
      }
    }
  }
}
